(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getLogoLists = (event) => {
      const section = event.target;

      if (!(section instanceof HTMLElement)) return [];
      if (!section.classList.contains('shopify-section--logo-list')) return [];

      return section.querySelectorAll('.logo-list__list');
    };

    document.addEventListener('shopify:section:load', (event) => {
      const jq = window.jQuery;

      if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

      getLogoLists(event).forEach((list) => {
        if (list.classList.contains('slick-initialized')) return;

        jq(list).slick({
          autoplay: true,
          arrows: false,
          autoplaySpeed: 0,
          speed: 4000,
          infinite: true,
          slidesToShow: 9,
          cssEase: 'linear',
          pauseOnHover: true,
          pauseOnFocus: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 6
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        });
      });
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const jq = window.jQuery;

      if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

      getLogoLists(event).forEach((list) => {
        if (list.classList.contains('slick-initialized')) {
          jq(list).slick('unslick');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
(() => {
  const storageKey = 'igk:cart:checkout-return';
  const checkoutSelector = '#mini-cart .checkout-button[name="checkout"]';
  let pendingReturn = null;

  function pinCheckoutLock(drawer) {
    const button = drawer.querySelector('.checkout-button');
    const text = button && button.querySelector('.loader-button__text');
    const lock = text && text.querySelector('.checkout-button__lock');
    if (lock) button.insertBefore(lock, text);
  }

  function watchCheckoutLock() {
    customElements.whenDefined('loader-button').then(() => {
      const drawer = document.getElementById('mini-cart');
      if (!drawer) return;
      pinCheckoutLock(drawer);
      new MutationObserver(() => pinCheckoutLock(drawer)).observe(drawer, {
        childList: true,
        subtree: true
      });
    });
  }

  function clearReturn() {
    pendingReturn = null;
    try {
      sessionStorage.removeItem(storageKey);
    } catch {}
  }

  function rememberCart(button) {
    if (!(button instanceof Element) || !button.matches(checkoutSelector) || button.disabled) return;
    const content = document.querySelector('#mini-cart .drawer__content');
    pendingReturn = {
      path: location.pathname + location.search,
      createdAt: Date.now(),
      scrollTop: content ? content.scrollTop : 0
    };
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(pendingReturn));
    } catch {}
  }

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.target instanceof Element) rememberCart(event.target.closest(checkoutSelector));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.defaultPrevented) rememberCart(event.submitter);
  }, true);

  function restoreCart(event) {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!event?.persisted && navigation?.type !== 'back_forward') {
      clearReturn();
      return;
    }
    let state = pendingReturn;
    try {
      state = JSON.parse(sessionStorage.getItem(storageKey));
    } catch {}
    if (!state) return;
    if (!Number.isFinite(state.createdAt) || Date.now() - state.createdAt > 3600000) {
      clearReturn();
      return;
    }
    if (state.path !== location.pathname + location.search) {
      clearReturn();
      return;
    }
    clearReturn();

    customElements.whenDefined('cart-drawer').then(() => {
      const drawer = document.getElementById('mini-cart');
      if (!drawer) return;
      if (!drawer.querySelector('.line-item')) return;
      pinCheckoutLock(drawer);
      if (!drawer.open) drawer.open = true;

      requestAnimationFrame(() => {
        const content = drawer.querySelector('.drawer__content');
        if (content) content.scrollTop = Number(state.scrollTop) || 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCheckoutLock, { once: true });
  } else {
    watchCheckoutLock();
  }
  window.addEventListener('pageshow', restoreCart);
  if (document.readyState === 'complete') restoreCart();
})();

  } catch(e) { console.error(e); }
})();
})();
